// extracted by mini-css-extract-plugin
export default {"background":"MSGZSList_background__kbxDY","lookMainPage":"MSGZSList_lookMainPage__9jXRY","videoTag":"MSGZSList_videoTag__rIhX5"};